import React, { Component } from 'react'
import Link from '../utils/link'
import { Logo } from './icons'

class Footer extends Component {
  
  render() {
    return (
      <footer className='footer'>
        <div className='footer__inner'>
          <div className='footer__top'>
            <div className='footer__col footer__col--logo'>
              <Link to='/'>
                <Logo />
              </Link>
            </div>
            <div className='footer__col footer__col--text'>
              <p>284 La Trobe Street, <br />Melbourne VIC 3000</p>
              <p><Link to='tel:+61393293266'>03 9329 3266</Link></p>
            </div>
            <div className='footer__col'>
              <ul>
                <li><Link to='/buy/'>Buy</Link></li>
                <li><Link to='/lease/'>Lease</Link></li>
                <li><Link to='/leased/'>Leased</Link></li>
                <li><Link to='/sold/'>Sold</Link></li>
              </ul>
            </div>
            <div className='footer__col'>
              <ul>
                <li><Link to='/projects/'>Projects</Link></li>
                <li><Link to='/commercial/'>Commercial</Link></li>
                <li><Link to='/manage/'>Manage</Link></li>
              </ul>
            </div>
            <div className='footer__col'>
              <ul>
                <li><Link to='/about/'>About Core</Link></li>
                <li><button onClick={() => document && document.querySelector('.header__nav--left li:first-of-type .header__subnav li button').click()}>Sales Appraisal</button></li>
                <li><button onClick={() => document && document.querySelector('.header__nav--left li:nth-of-type(2) .header__subnav li button').click()}>Rental Appraisal</button></li>
                <li><Link to='/team/'>Our Team</Link></li>
              </ul>
            </div>
            <div className='footer__col'>
              <ul>
                <li><button onClick={() => document && document.querySelector('.header__nav--right li button').click()}>Contact Us</button></li>
                <li><Link to='https://www.instagram.com/corerealty_au/'>Instagram</Link></li>
                <li><Link to='https://www.facebook.com/CoreRealty/'>Facebook</Link></li>
                <li><Link to='tel:+61393293266'>Call Us</Link></li>
              </ul>
            </div>
          </div>
          <div className='footer__bottom'>
            <div className='footer__col'>
              <ul>
                <li><Link to='/privacy-policy/'>Privacy Policy</Link></li>
                <li><Link to='/terms-conditions/'>Terms &amp; Conditions</Link></li>
              </ul>
            </div>
            <div className='footer__col'>
              <ul>
                <li>© Core Realty, { new Date().getFullYear() }</li>
                <li><Link to='https://www.lbdstudios.com.au/' title={'Site credit: LBD STUDIOS'}>LBD STUDIOS</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
